import {Stack} from '../layout/stack/stack';
import {Body} from '../typography/body';

import styles from './connection-info-title.module.css';

interface Props {
    icon: React.ReactElement<any>;
    primaryText: string;
    secondaryText?: string | null | undefined;
    tertiaryText?: string | null | undefined;
}

export function ConnectionInfoTitle(props: Props) {
    const Icon = props.icon;

    return (
        <div className={styles.container}>
            <Stack spacing={16} isHorizontal={true} alignItems='center'>
                {Icon}
                <div className='flex flex-dir-col gap-4'>
                    <Body size='small' color='dark'>
                        {props.primaryText}
                    </Body>
                    {props.secondaryText && (
                        <Body size='small' color='light'>
                            {props.secondaryText}
                        </Body>
                    )}
                    {props.tertiaryText && (
                        <Body size='small' color='light'>
                            {props.tertiaryText}
                        </Body>
                    )}
                </div>
            </Stack>
        </div>
    );
}
